import { useEffect } from 'react';

const SITE_NAME = 'Roam Together';

/**
 * Next's `metadata.title` with the `%s · Roam Together` template, as a hook.
 * Pass `null` to leave the default title in place.
 */
export function usePageTitle(title: string | null | undefined) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
    return () => {
      document.title = previous;
    };
  }, [title]);
}

/** Same for the meta description, which crawlers and link previews read. */
export function usePageDescription(description: string | null | undefined) {
  useEffect(() => {
    if (!description) return;
    const tag = document.querySelector('meta[name="description"]');
    if (!tag) return;
    const previous = tag.getAttribute('content');
    tag.setAttribute('content', description);
    return () => {
      if (previous !== null) tag.setAttribute('content', previous);
    };
  }, [description]);
}
